import { render, staticRenderFns } from "./wearing-guide.vue?vue&type=template&id=c4de5dbc&"
import script from "./wearing-guide.vue?vue&type=script&lang=js&"
export * from "./wearing-guide.vue?vue&type=script&lang=js&"
import style0 from "./wearing-guide.vue?vue&type=style&index=0&id=c4de5dbc&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports